import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../core/guards/auth.guard';
import { WorkflowMainComponent } from './workflow-main/workflow-main.component';
import { WorkflowGridComponent } from './workflow-grid/workflow-grid.component';

/**
 * Workflow routes mapped from AngularJS ui-router states in workflow/workflow.js:
 *   workflow        -> /workflow        -> WorkflowMainComponent (shell)
 *   workflow.list   -> /workflow/list   -> WorkflowGridComponent
 */
const routes: Routes = [
  {
    path: 'workflow',
    component: WorkflowMainComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'list', pathMatch: 'full' },
      { path: 'list', component: WorkflowGridComponent, data: { title: 'Workflow List' } },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class WorkflowRoutingModule {}
